import type { IconData } from '@stacksjs/iconify-core'

export const shield: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 4.386V8a9.02 9.02 0 0 0 3.08 6.787L8 17.342l2.92-2.555A9.02 9.02 0 0 0 14 8V4.386l-6-2.25zM.649 2.756L8 0l7.351 2.757a1 1 0 0 1 .649.936V8c0 3.177-1.372 6.2-3.763 8.293L8 20l-4.237-3.707A11.02 11.02 0 0 1 0 8V3.693a1 1 0 0 1 .649-.936z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shield
